.i{display:flex;}